@use '../../sass/theme';
@use '../../sass/loader';

:host {
  appearance: unset !important;
}
:host([disabled]) {
  pointer-events: none;
  touch-action: none;
}
:host([disabled='false']) {
  pointer-events: auto;
  touch-action: auto;
}

// todo - we want low/high emphasis colours rather than light/dark

$variants: primary, secondary, success, info, warning, danger, low, high, subtle;

@mixin get-variants() {
  @each $variant in $variants {
    &.#{$variant} {
      color: var(--jui-#{$variant}-color--contrast);
      background-color: var(--jui-#{$variant}-color);
      border-color: var(--jui-#{$variant}-color);

      &:hover {
        background-color: var(--jui-#{$variant}-color--darker);
        border-color: var(--jui-#{$variant}-color--darker);
      }

      &:active {
        background-color: var(--jui-#{$variant}-color--darkest);
        border-color: var(--jui-#{$variant}-color--darker);
      }

      & ::slotted([slot='icon']) {
        color: var(--jui-#{$variant}-color--contrast) !important;
      }
    }
  }
}

@mixin get-ghost-variants() {
  @each $variant, $font-color in $variants {
    &.#{$variant} {
      color: var(--jui-#{$variant}-color);
      &:hover {
        color: var(--jui-#{$variant}-color--contrast);
        & ::slotted([slot='icon']) {
          color: var(--jui-#{$variant}-color--contrast) !important;
        }
      }
      & ::slotted([slot='icon']) {
        color: var(--jui-#{$variant}-color) !important;
      }
    }
  }
}

button {
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 5px 20px;
  outline: none;
  font-family: var(--jui-font-family);
  border: 1px solid var(--jui-primary-color);
  border-radius: var(--jui-btn-border-radius);
  line-height: 1.5;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color var(--jui-transition-out), color var(--jui-transition-out),
    border-color var(--jui-transition-out);
  user-select: text;
  vertical-align: bottom !important;
  word-break: normal;

  &:hover {
    transition: background-color var(--jui-transition-in), color var(--jui-transition-in),
      border-color var(--jui-transition-in);
    & ::slotted([slot='icon']) {
      transition: color var(--jui-transition-in);
    }
  }

  &:focus {
    box-shadow: 0 0 0 3px rgba(21, 156, 228, 0.4);
  }

  &:disabled {
    opacity: 0.7;
    pointer-events: none;
    transition: background-color var(--jui-transition-out), color var(--jui-transition-out);
  }

  & ::slotted([slot='icon']) {
    line-height: 1 !important;
    font-size: 1.5rem !important;
    margin-left: 6px !important;
    margin-right: 6px !important;
    transition: color var(--jui-transition-out);
  }

  // EXPAND
  &.expand {
    display: flex;
    width: 100%;
    height: 100%;
  }

  &.disableUserSelect {
    user-select: none;
  }

  @include get-variants;

  &.subtle {
    background-color: transparent;
    border: unset;
    color: var(--jui-secondary-color--darker);

    &:hover {
      background-color: var(--jui-light-color);
      border-color: var(--jui-light-color);
    }

    &:active {
      background-color: var(--jui-light-color--darker);
      border-color: var(--jui-light-color);
    }
  }

  // SIZES
  &.xs {
    padding: var(--jds-space-inset-squish-xxs);
    font-size: 0.7rem;
    line-height: 1.25;

    & ::slotted([slot='icon']) {
      font-size: 0.85rem !important;
      margin-left: 3px !important;
      margin-right: 3px !important;
    }
  }

  &.sm {
    padding: var(--jds-space-inset-squish-xs);
    font-size: 0.8rem;

    & ::slotted([slot='icon']) {
      font-size: 1.2rem !important;
      margin-left: 4px !important;
      margin-right: 4px !important;
    }
  }

  &.md {
    padding: var(--jds-space-inset-squish-xs);
    font-size: 1rem;
  }

  &.lg {
    padding: var(--jds-space-inset-squish-sm);
    font-size: 1.1rem;

    & ::slotted([slot='icon']) {
      font-size: 1.4rem !important;
    }
  }

  &.xl {
    padding: var(--jds-space-inset-squish);
    font-size: 1.25rem;
    border-radius: calc(var(--jui-btn-border-radius) + 1px);

    & ::slotted([slot='icon']) {
      font-size: 1.7rem !important;
      margin-left: 8px !important;
      margin-right: 8px !important;
    }
  }

  // DISPLAY
  &.ghost {
    background-color: transparent;

    @include get-ghost-variants;
  }
}
